import React from 'react';
interface CtaButtonProps {
  text: string;
  className?: string;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg' | 'xl';
  onClick?: () => void;
}
export function CtaButton({
  text,
  className = '',
  variant = 'primary',
  size = 'lg',
  onClick
}: CtaButtonProps) {
  const sizeClasses = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  const variantClasses = {
    primary: 'bg-brand-yellow text-brand-purpleDark hover:bg-[#E5B515] shadow-[0_8px_20px_rgba(250,204,21,0.3)] hover:shadow-[0_12px_25px_rgba(250,204,21,0.4)]',
    secondary: 'bg-brand-purple text-white hover:bg-[#5A1A8A] shadow-[0_8px_20px_rgba(107,33,168,0.3)] hover:shadow-[0_12px_25px_rgba(107,33,168,0.4)]'
  };
  const handleClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    if (onClick) onClick();
  };
  return <a href="https://www.mareaa.online/cart/53237108638061:1" onClick={handleClick} className={`
        inline-flex items-center justify-center gap-2 
        font-sans font-bold rounded-xl
        transition-all duration-300 transform hover:-translate-y-1
        text-center w-full sm:w-auto
        ${sizeClasses[size]}
        ${variantClasses[variant]}
        ${className}
      `} data-id="element-35">
      <span data-id="element-36">{text}</span>
    </a>;
}